import * as React from "react";
import { makeStyles } from "@material-ui/core";
import Clipboard from "react-clipboard.js";
import { toast } from "react-toastify";
import AboutUsButton from "common/components/AboutUsButton";
import { connect } from "common/connect";
import { GetCurrentGameId, GetCurrentGamePrefix } from "common/constants/Games";
import EventHelper from "common/helpers/eventHelper/eventHelper";
import Store from "common/store";
import StoreKeys from "common/storeKeys";
import UserManager from "common/userManager";
import LookupService from "services/LookupService";
import { ReactComponent as DiscordIcon } from "icons/DiscordIcon.svg";
import { ReactComponent as InstagramIcon } from "icons/InstagramIcon.svg";
import { ReactComponent as RedditIcon } from "icons/RedditIcon.svg";
import { ReactComponent as TwitterIcon } from "icons/TwitterIcon.svg";
import { ReactComponent as ShareIcon } from "icons/ShareIcon.svg";

const propKeys = {
	eventData: StoreKeys.EVENT.EVENTDATA,
	games: StoreKeys.GAMES,
};

const useStyles = makeStyles(() => {
	return {
		panel: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		icon: {
			cursor: "pointer",
			margin: "2px 4px",
			width: 32,
			height: 32,
		},
	};
});

function SocialPanelC({ eventData, games }) {
	const styles = useStyles();

	const clickShare = () => {
		toast("Link Copied!", { type: "success", toastId: "link-copied" });
	};

	React.useEffect(() => {
		if (!games) {
			LookupService.getGames().then((games) => {
				Store.set(StoreKeys.GAMES, games);
			});
		}
	});

	const gameId = GetCurrentGameId();
	const gamePrefix = GetCurrentGamePrefix();
	const currentGame = games?.find((g) => g.id === gameId);

	const shareLink =
		"https://" +
		window.location.host +
		gamePrefix +
		"/event/" +
		EventHelper.currentEventId +
		"/" +
		(EventHelper.currentUserId ?? UserManager.getUserId());

	return (
		<div className={styles.panel}>
			<AboutUsButton />
			{eventData && (
				<Clipboard
					component="div"
					style={{ display: "contents" }}
					data-clipboard-text={shareLink}
					onClick={() => clickShare()}
				>
					<ShareIcon title="Share" className={styles.icon} />
				</Clipboard>
			)}
			<DiscordIcon
				title="Discord"
				onClick={() => {
					window.open("https://discord.gg/r8ujzkRYeF", "_blank");
				}}
				className={styles.icon}
			/>
			<InstagramIcon
				title="Instagram"
				onClick={() => {
					if (currentGame?.instagramUrl) {
						window.open(currentGame.instagramUrl, "_blank");
					}
				}}
				className={styles.icon}
			/>
			<TwitterIcon
				title="Twitter"
				onClick={() => {
					if (currentGame?.twitterUrl) {
						window.open(currentGame.twitterUrl, "_blank");
					}
				}}
				className={styles.icon}
			/>
			<RedditIcon
				title="Reddit"
				onClick={() => {
					window.open("https://www.reddit.com/user/pickstopgg/", "_blank");
				}}
				className={styles.icon}
			/>
		</div>
	);
}

export default function SocialPanel(props) {
	return connect(<SocialPanelC />, propKeys, props);
}
